<router-outlet />
@if (!Capacitor.isNativePlatform()) {
  <rrp-cookie-banner/>
}
<lib-toast />
